import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import "./resultPopUp.scss"
import { SocketState } from '../../../context/SocketProvider';
import { toast } from 'react-toastify';
import ModalContainer from '../../../2d-game/modals/ModalContainer';
import { selectPickTrNo } from '../../../redux/3d_game_Slice/gameinfo3d';

function CancelCoupon(props) {
  const navigate = useNavigate();
  const { socket } = SocketState();
  const [ticketID, setTicketID] = useState('');
  const [lastTicketModal, setLastTicketModal] = useState(false);
  let lastTicketId = useSelector(selectPickTrNo)

  // You'll need to get the last ticket ID from your state or API
  // For now, I'll assume you have a way to get it
  useEffect(() => {
    // Fetch or set the last ticket ID here
    // Example: setLastTicketId(getLastTicketIdFromState());
  }, []);

  const cancelTicket = (ticketIdToCancel = null) => {
    const ticketId = ticketIdToCancel || ticketID;

    if (!ticketId.trim()) {
      toast.warning("Please enter a ticket ID");
      return;
    }

    const data = {
      "en": "PICK_THREE_CANCEL_TICKET",
      "data": {
        "ticket_id": ticketId,
      }
    };
    socket.emit("req", data);
    setTicketID('');
    setLastTicketModal(false);
  };

  const handleLastTicketCancel = () => {
    if (!lastTicketId) {
      toast.warning("No last ticket found");
      return;
    }
    setLastTicketModal(true);
  };

  return (
    <>
      <ModalContainer title={'Cancel Coupon'} navigation={'/3d'}>
        <div className='flex w-[90%] mx-auto flex-wrap  overflow-y-auto'>
          <div className='w-full flex justify-content-center'>
            <div className='w-50 c-height-table pt-5 overflow-hidden'>
              <div className='bg-[#e54859] w-100 text-white p-3 pt-3 pb-3 mb-3 font-bold f-24 '>Enter Ticket ID</div>
              <div className=' w-100 pb-5'>
                <input
                  type="text"
                  className="bg-white text-black form-control input-box-wrapper p-3 pt-3 pb-3 h-100 font-bold f-24"
                  placeholder='Ticket Id'
                  value={ticketID}
                  onChange={(e) => {
                    setTicketID(e.target.value)
                  }}
                />
              </div>

              <div className='flex justify-center gap-4 mt-4'>
                <button
                  className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={handleLastTicketCancel}
                >
                  Cancel Last Ticket
                </button>
                <button
                  className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={() => cancelTicket()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>

      {lastTicketModal && <div className="modal fade show bg-black bg-opacity-70" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="modal-dialog modal-dialog-small- modal-dialog-centered modal-dialog-scrollable" style={{ width: "45%", height: "40vh" }}>
          <div className="modal-content">
            <div className="modal-header">
              <div className="myacc_tab_sec">
                <button type="button" data-toggle="tooltip" data-html="true"
                  title="Press Space button to close the popup window" className="btn-close popup-close"
                  data-bs-dismiss="modal"
                  onClick={() => setLastTicketModal(false)}
                >
                  <img src="/images/close_btn.png" className="popupclose_icon modal_close" />
                </button>
                <ul className="myacc_tab_nav nav" role="tablist">
                  <li className="nav-item">
                    <p className="nav-link">
                      Cancel Last Ticket
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* body */}
            <div className="modal-body">
              <div className='w-full' style={{ height: "200px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <p style={{ fontSize: "18px" }}>Are you sure you want cancel last ticket?</p>
              </div>
              <div
                className='flex gap-2'
                style={{
                  position: "absolute",
                  bottom: "20px",
                  right: "20px",
                }}
              >
                <button
                  className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={() => setLastTicketModal(false)}
                >
                  No
                </button>
                <button
                  className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={() => cancelTicket(lastTicketId)}
                >
                  Yes
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>}
    </>
  )
}

export default CancelCoupon